/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Text from 'ContentComponents/cmv2/fields/Text';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { TEXT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT, VALIDATION_REGEX, VALIDATION_ERROR_MESSAGE, PLACEHOLDER, SHOW_EMOJI_PICKER, ALLOW_NEW_LINE } from 'DesignData/enums/CustomWidgetFieldAttributes';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import UILink from 'UIComponents/link/UILink';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import UIToggle from 'UIComponents/input/UIToggle';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

export default class _class extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      invalidRegex: false
    };

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };

    this.onPlaceholderChange = e => {
      this.props.editField({
        [PLACEHOLDER]: e.target.value
      });
    };

    this.onValidationRegexChange = e => {
      this.props.editField({
        [VALIDATION_REGEX]: e.target.value
      });
    };

    this.onValidationErrorMessageChange = e => {
      this.props.editField({
        [VALIDATION_ERROR_MESSAGE]: e.target.value
      });
    };

    this.onShowEmojiPickerChange = ({
      target: {
        checked
      }
    }) => {
      this.props.editField({
        [SHOW_EMOJI_PICKER]: checked
      });
    };

    this.renderValidationRegexTooltip = () => {
      return /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('text.regex.helpText')
        }), /*#__PURE__*/_jsx(UILink, {
          className: "m-left-2",
          href: "https://www.w3schools.com/jsref/jsref_obj_regexp.asp",
          target: "_blank",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('text.regex.learnMore')
          })
        })]
      });
    };
  }

  render() {
    const {
      field,
      fieldErrors,
      readOnly,
      isV1
    } = this.props;

    const defaultTextInput = /*#__PURE__*/_jsx(FormControlWithErrors, {
      errors: fieldErrors[DEFAULT],
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`defaultLabels.${TEXT}`)
      }),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        inputComponent: Text,
        onFieldChange: this.onDefaultChange,
        value: field[DEFAULT],
        readOnly: readOnly,
        placeholder: field[PLACEHOLDER],
        show_emoji_picker: field[SHOW_EMOJI_PICKER],
        allow_new_line: field[ALLOW_NEW_LINE]
      })
    });

    if (isV1) {
      return /*#__PURE__*/_jsx("div", {
        className: "text-content-options",
        children: /*#__PURE__*/_jsx(ToolFieldset, {
          children: defaultTextInput
        })
      });
    }

    const regexValidationMessage = fieldErrors['validation_regex'] ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('text.regex.invalidRegex')
    }) : null;
    return /*#__PURE__*/_jsx("div", {
      className: "text-content-options",
      children: /*#__PURE__*/_jsxs(ToolFieldset, {
        children: [defaultTextInput, /*#__PURE__*/_jsx(ToolFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('text.placeholderLabel')
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            "data-test-id": "module-text-field-placeholder-input",
            onChange: this.onPlaceholderChange,
            value: field[PLACEHOLDER],
            disabled: readOnly || isV1
          })
        }), /*#__PURE__*/_jsx(ToolFormControl, {
          error: fieldErrors['validation_regex'],
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('text.regex.label')
          }),
          tooltip: this.renderValidationRegexTooltip(),
          tooltipPlacement: "top left",
          validationMessage: regexValidationMessage,
          children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
            text: "/",
            position: "start",
            children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
              text: "/",
              position: "end",
              children: /*#__PURE__*/_jsx(UITextInput, {
                className: "validation-regex-input",
                "data-test-id": "module-text-field-regex-input",
                onChange: this.onValidationRegexChange,
                placeholder: text(i18nKey('text.regex.placeholder')),
                value: field[VALIDATION_REGEX],
                disabled: readOnly || isV1
              })
            })
          })
        }), /*#__PURE__*/_jsx(ToolFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('text.validationErrorMessage.label')
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('text.validationErrorMessage.tooltip')
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            disabled: readOnly || isV1,
            onChange: this.onValidationErrorMessageChange,
            value: field[VALIDATION_ERROR_MESSAGE]
          })
        }), /*#__PURE__*/_jsx(ToolFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('text.emoji.label')
          }),
          children: /*#__PURE__*/_jsx(UIToggle, {
            "data-test-id": "module-text-field-emoji-picker",
            size: "extra-small",
            onChange: this.onShowEmojiPickerChange,
            checked: field[SHOW_EMOJI_PICKER],
            disabled: readOnly || isV1
          })
        })]
      })
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object,
  readOnly: PropTypes.bool,
  isV1: PropTypes.bool.isRequired
};
_class.defaultProps = {
  fieldErrors: {}
};